import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from '@react-md/dialog';
import { Button } from '../';
import Timer from 'react-compound-timer';
import './SessionDialog.scss';

const SessionDialog = ({ visible, onHide, onContinue, onSignOut, onTimeExpire, message, duration = 60000 }) => {
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    onHide();
  };

  const handleSignOut = () => {
    if (onSignOut) {
      onSignOut();
    }
    onHide();
  };

  return (
    <Dialog
      id="ph-session-dialog"
      visible={visible}
      onRequestClose={onHide}
      aria-labelledby="session-dialog"
    >
      <DialogContent>
        <p id="session expire" className="md-color--secondary-text">
          {message}
          <br />
          <Timer
            initialTime={duration} // 60 seconds
            direction="backward"
            checkpoints={[
              {
                time: 0,
                callback: () => onTimeExpire(),
              }
            ]}
          >
            <Timer.Seconds /> seconds
          </Timer>
        </p>
      </DialogContent>
      <DialogFooter>
        <Button className="filled secondary" id="ph-session-dialog-sign-out-button" onClick={handleSignOut}>
          Sign out
        </Button>
        <Button className="filled primary" id="ph-session-dialog-continue-button" onClick={handleContinue}>
          Continue
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

SessionDialog.propTypes = {
  duration: PropTypes.number,
  message: PropTypes.string,
  onContinue: PropTypes.func,
  onHide: PropTypes.func.isRequired,
  onSignOut: PropTypes.func,
  onTimeExpire: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired
};

SessionDialog.defaultProps = {
  duration: 60000,
  message: 'Your session is about to expire!',
  visible: false
};

export default SessionDialog;
